import React, { useState, useEffect } from 'react';
import './SocietyBlogs.css';
import logs from "../../Assets/Image/logos.png";
import { Link } from 'react-router-dom';

const SocietyBlogs = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sidebarScroll, setSidebarScroll] = useState(0);
  const blogsPerPage = 8;
  
const allBlogs = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&h=600&fit=crop',
      title: 'The Future of Collaborative Workspaces in 2026',
      type: 'Technology',
      description: 'Exploring how modern societies are reshaping the workplace through innovative design and digital integration.',
      date: 'Feb 1, 2026',
      author: 'Sarah Chen',
      featured: true
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop',
      title: 'Building Sustainable Communities',
      type: 'Lifestyle',
      description: 'How neighborhood initiatives are creating lasting environmental impact through collective action.',
      date: 'Jan 30, 2026',
      author: 'Michael Torres',
      featured: true
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800&h=600&fit=crop',
      title: 'Digital Transformation in Local Governance',
      type: 'Innovation',
      description: 'Society management platforms are revolutionizing how communities interact and make decisions.',
      date: 'Jan 28, 2026',
      author: 'Elena Rodriguez',
      featured: true
    },
    {
      id: 11,
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop',
      title: 'Smart City Integration for Residential Societies',
      type: 'Technology',
      description: 'Connecting residential communities with smart city infrastructure for enhanced living.',
      date: 'Jan 27, 2026',
      author: 'Alex Kumar',
      featured: true
    },
    {
      id: 12,
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop',
      title: 'Financial Planning for Society Development',
      type: 'Finance',
      description: 'Strategic budgeting and investment approaches for long-term community growth.',
      date: 'Jan 26, 2026',
      author: 'Maria Santos',
      featured: true
    },
    {
      id: 13,
      image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=600&fit=crop',
      title: 'Community Wellness Programs That Work',
      type: 'Wellness',
      description: 'Proven strategies for implementing successful health initiatives in residential communities.',
      date: 'Jan 24, 2026',
      author: 'Dr. James Lee',
      featured: true
    },
    {
      id: 4,
      image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&h=600&fit=crop',
      title: 'The Art of Neighborhood Engagement',
      type: 'Community',
      description: 'Creative strategies for fostering meaningful connections in residential communities.',
      date: 'Jan 25, 2026',
      author: 'David Kim'
    },
    {
      id: 5,
      image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=800&h=600&fit=crop',
      title: 'Smart Security Systems for Modern Living',
      type: 'Technology',
      description: 'Balancing privacy and safety in the age of intelligent surveillance and access control.',
      date: 'Jan 22, 2026',
      author: 'Priya Sharma'
    },
    {
      id: 6,
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop',
      title: 'Green Spaces and Mental Wellbeing',
      type: 'Wellness',
      description: 'Research reveals the profound impact of community gardens on resident happiness.',
      date: 'Jan 20, 2026',
      author: 'James Wilson'
    },
    {
      id: 7,
      image: 'https://images.unsplash.com/photo-1560439514-4e9645039924?w=800&h=600&fit=crop',
      title: 'Managing Multi-Generational Communities',
      type: 'Culture',
      description: 'Creating inclusive spaces that serve the needs of diverse age groups and backgrounds.',
      date: 'Jan 18, 2026',
      author: 'Aisha Patel'
    },
    {
      id: 8,
      image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&h=600&fit=crop',
      title: 'Financial Transparency in Society Management',
      type: 'Finance',
      description: 'Best practices for maintaining trust through clear communication and accountable budgeting.',
      date: 'Jan 15, 2026',
      author: 'Robert Chang'
    },
    {
      id: 9,
      image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&h=600&fit=crop',
      title: 'Event Planning for Community Bonding',
      type: 'Events',
      description: 'Transform ordinary gatherings into memorable experiences that strengthen neighborhood ties.',
      date: 'Jan 12, 2026',
      author: 'Lisa Anderson'
    },
    {
      id: 10,
      image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&h=600&fit=crop',
      title: 'Conflict Resolution in Shared Spaces',
      type: 'Management',
      description: 'Proven mediation techniques for addressing disputes while preserving community harmony.',
      date: 'Jan 10, 2026',
      author: 'Marcus Johnson'
    }
  ];

  // Today's blogs for sidebar
  const todaysBlogs = [
    {
      id: 101,
      image: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=400&h=300&fit=crop',
      title: 'Morning Brief: Community Updates',
      type: 'News'
    },
    {
      id: 102,
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
      title: 'Tech Innovations in Society Management',
      type: 'Technology'
    },
    {
      id: 103,
      image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=300&fit=crop',
      title: 'Resident Safety Tips for 2026',
      type: 'Safety'
    },
    {
      id: 104,
      image: 'https://images.unsplash.com/photo-1560439514-4e9645039924?w=400&h=300&fit=crop',
      title: 'Green Living Success Stories',
      type: 'Environment'
    },
    {
      id: 105,
      image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=400&h=300&fit=crop',
      title: 'Financial Wellness Workshop Recap',
      type: 'Finance'
    },
    {
      id: 106,
      image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=400&h=300&fit=crop',
      title: 'Community Event Highlights',
      type: 'Events'
    }
  ];

  const recentBlogs = allBlogs.filter(blog => blog.featured);
  
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = allBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(allBlogs.length / blogsPerPage);

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? recentBlogs.length - 1 : prev - 1));
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev === recentBlogs.length - 1 ? 0 : prev + 1));
  };

  const handleSidebarPrev = () => {
    setSidebarScroll((prev) => Math.max(0, prev - 1));
  };

  const handleSidebarNext = () => {
    setSidebarScroll((prev) => Math.min(todaysBlogs.length - 3, prev + 1));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    const section = document.querySelector('.society-blog-grid-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="society-blog-container">
      {/* Hero Landing Section */}
      <section className="society-blog-hero">
        <div className="society-blog-hero-overlay"></div>
        <div className="society-blog-hero-main">
          <div className="society-blog-hero-content">
            <span className="society-blog-hero-label">Insights & Stories</span>
            <h1 className="society-blog-hero-title">
              Shaping the Future of<br />Community Living
            </h1>
            <p className="society-blog-hero-description">
              Discover perspectives on modern society management, sustainable living,
              and the innovations transforming residential communities worldwide.
            </p>
            <button className="society-blog-hero-cta">Explore Articles</button>
          </div>
          <div className="society-blog-hero-image">
            <img 
              src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&h=900&fit=crop" 
              alt="Modern workspace" 
            />
          </div>
        </div>

        {/* Today's Blogs Sidebar */}
        <div className="society-blog-sidebar">
          <div className="society-blog-sidebar-header">
            <h3 className="society-blog-sidebar-title">Today's Blogs</h3>
            <div className="society-blog-sidebar-controls">
              <button 
                className="society-blog-sidebar-btn"
                onClick={handleSidebarPrev}
                disabled={sidebarScroll === 0}
              >
                ↑
              </button>
              <button 
                className="society-blog-sidebar-btn"
                onClick={handleSidebarNext}
                disabled={sidebarScroll >= todaysBlogs.length - 3}
              >
                ↓
              </button>
            </div>
          </div>
          <div className="society-blog-sidebar-list">
            <div 
              className="society-blog-sidebar-track"
              style={{ transform: `translateY(-${sidebarScroll * 120}px)` }}
            >
              {todaysBlogs.map((blog) => (
                <div key={blog.id} className="society-blog-sidebar-item">
                  <div className="society-blog-sidebar-item-image">
                    <img src={blog.image} alt={blog.title} />
                  </div>
                  <div className="society-blog-sidebar-item-content">
                    <span className="society-blog-sidebar-item-type">{blog.type}</span>
                    <h4 className="society-blog-sidebar-item-title">{blog.title}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Recent Blogs Carousel */}
      <section className="society-blog-recent">
        <div className="society-blog-section-header">
          <h2 className="society-blog-section-title">Recent Highlights</h2>
          <div className="society-blog-carousel-controls">
            <button 
              className="society-blog-carousel-btn society-blog-carousel-prev" 
              onClick={handlePrevSlide}
              aria-label="Previous blog"
            >
              ←
            </button>
            <button 
              className="society-blog-carousel-btn society-blog-carousel-next" 
              onClick={handleNextSlide}
              aria-label="Next blog"
            >
              →
            </button>
          </div>
        </div>

        <div className="society-blog-carousel-wrapper">
          <div 
            className="society-blog-carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {recentBlogs.map((blog) => (
              <div key={blog.id} className="society-blog-carousel-slide">
                <div className="society-blog-featured-card">
                  <div className="society-blog-featured-image">
                    <img src={blog.image} alt={blog.title} />
                    <span className="society-blog-featured-badge">Featured</span>
                  </div>
                  <div className="society-blog-featured-content">
                    <span className="society-blog-featured-type">{blog.type}</span>
                    <h3 className="society-blog-featured-title">{blog.title}</h3>
                    <p className="society-blog-featured-description">{blog.description}</p>
                    <div className="society-blog-featured-meta">
                      <span className="society-blog-featured-author">{blog.author}</span>
                      <span className="society-blog-featured-divider">•</span>
                      <span className="society-blog-featured-date">{blog.date}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="society-blog-carousel-indicators">
          {recentBlogs.map((_, index) => (
            <button
              key={index}
              className={`society-blog-carousel-indicator ${currentSlide === index ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </section>

      {/* All Blogs Grid */}
      <section className="society-blog-grid-section">
        <div className="society-blog-section-header">
          <h2 className="society-blog-section-title">All Articles</h2>
          <p className="society-blog-section-subtitle">
            Browse our complete collection of insights and stories
          </p>
        </div>

        <div className="society-blog-grid">
          {currentBlogs.map((blog) => (
            <article key={blog.id} className="society-blog-card">
              <div className="society-blog-card-image">
                <img src={blog.image} alt={blog.title} />
                <div className="society-blog-card-overlay">
                  <button className="society-blog-card-read-btn">Read Article</button>
                </div>
              </div>
              <div className="society-blog-card-content">
                <span className="society-blog-card-type">{blog.type}</span>
                <h3 className="society-blog-card-title">{blog.title}</h3>
                <p className="society-blog-card-description">{blog.description}</p>
                <div className="society-blog-card-meta">
                  <span className="society-blog-card-author">{blog.author}</span>
                  <span className="society-blog-card-date">{blog.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Pagination */}
        <div className="society-blog-pagination">
          <button 
            className="society-blog-pagination-btn society-blog-pagination-prev"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ← Previous
          </button>
          
          <div className="society-blog-pagination-numbers">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                className={`society-blog-pagination-number ${currentPage === index + 1 ? 'active' : ''}`}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div>

          <button 
            className="society-blog-pagination-btn society-blog-pagination-next"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next →
          </button>
        </div>
      </section>

      {/* Check Our Blogs CTA Section */}
      <section className="society-blog-cta">
        <div className="society-blog-cta-content">
          <h2 className="society-blog-cta-title">Stay Informed, Stay Connected</h2>
          <p className="society-blog-cta-description">
            Subscribe to our newsletter and never miss an update on community management best practices,
            innovative solutions, and inspiring success stories.
          </p>
          <div className="society-blog-cta-form">
            <input 
              type="email" 
              placeholder="Enter your email address" 
              className="society-blog-cta-input"
            />
            <button className="society-blog-cta-button">Subscribe Now</button>
          </div>
          <div className="society-blog-cta-stats">
            <div className="society-blog-cta-stat">
              <span className="society-blog-cta-stat-number">500+</span>
              <span className="society-blog-cta-stat-label">Articles Published</span>
            </div>
            <div className="society-blog-cta-stat">
              <span className="society-blog-cta-stat-number">50K+</span>
              <span className="society-blog-cta-stat-label">Monthly Readers</span>
            </div>
            <div className="society-blog-cta-stat">
              <span className="society-blog-cta-stat-number">1000+</span>
              <span className="society-blog-cta-stat-label">Communities Served</span>
            </div>
          </div>
        </div>
      </section>
      
      {/* ====== footer =========== */}
        <div className="footer-society-copyright mb-5">
           <p>
           © Copyright 2026 | Reserved by{" "}
           <b style={{ color: "#52BFE5" }}> Ohhpro Technologies Pvt.Ltd</b>
        </p>
        </div>
    </div>
  );
};

export default SocietyBlogs;